export const enum eAccountManageProfileTabNames {
  ProfilePicture = 'AbpAccount::ProfileTab:Picture',
  ChangePassword = 'AbpAccount::ProfileTab:Password',
  PersonalInfo = 'AbpAccount::ProfileTab:PersonalInfo',
  AuthenticatorApp = 'AbpAccount::ProfileTab:AuthenticatorApp',
  TwoFactor = 'AbpAccount::ProfileTab:TwoFactor',
}
